<template>
  <layout-main-inner title="考试查询">
    <div slot="action">
      <el-button
        type="primary"
        @click="additem">
        新增考试
      </el-button>
      <el-button
        type="primary"
        @click="downloadtmp">下载成绩模板</el-button>
    </div>
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-input
          v-model="config.courseExamName"
          clearable
          placeholder="请输入考试名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="考试名称"
          min-width="140"
          prop="courseExamName">
          <template slot-scope="{ row }">
            <el-link
              style="font-size:12px"
              :underline="false"
              type="primary"
              @click="toDetail(row)">{{ row.courseExamName }}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          label="考试时间"
          width="180"
          prop="examTime">
        </el-table-column>
        <el-table-column
          label="考试人数"
          width="180"
          prop="userCount">
        </el-table-column>
        <el-table-column
          label="是否可查成绩"
          width="110">
          <template slot-scope="{ row }">
            {{ row.queryScoreStatus === 1 ? '是': '否' }}
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="150">
          <template slot-scope="{ row }">
            <span>{{ row.createdTime | dateformat() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="165">
          <template slot-scope="{ row }">
            <el-button
              type="info"
              @click="updateitem(row)">编辑</el-button>
            <el-dropdown>
              <el-button
                type="primary"
                style="margin-left: 10px;">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="deleteitem(row)">删除</el-dropdown-item>
                <el-dropdown-item @click.native="uploadtmp(row)">导入成绩</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </layout-card-wrap>
    <edit-score-modal
      ref="score"
      :callback="() => { getlist() }"
    />
    <el-upload
      ref="elUpload"
      action=""
      :limit="1"
      style="display: none;"
      accept=".xls,.xlsx"
      :show-file-list="false"
      :http-request="handleHttpRequest"
    >
      <i ref="upload"></i>
    </el-upload>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import EditScoreModal from './edit-score-modal.vue'
export default {
  name: 'LuxuryCourseScoreIndex',
  components: { EditScoreModal },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      courseExamId: null,
      config: {
        pageNum: 1,
        pageSize: 10,
        courseExamName: ''
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    downloadtmp() {
      this.loading = true
      this.$store.dispatch('account/downloadcoursescoretemplate', {
        payload: {},
        success: () => {
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleHttpRequest(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      formData.append('courseExamId', this.courseExamId)
      this.loading = true
      this.$store.dispatch('account/uploadcoursescore', {
        payload: formData,
        success: () => {
          this.loading = false
          this.$message.success('上传成功')
          this.$refs.elUpload.clearFiles()
          this.getlist()
        },
        fail: () => {
          this.$refs.elUpload.clearFiles()
          this.loading = false
        }
      })
    },
    uploadtmp(row) {
      this.courseExamId = row.courseExamId
      this.$refs.upload.click()
    },
    toDetail(row) {
      this.$router.push('/luxury-course-score-detail?courseExamId=' + row.courseExamId)
    },
    updateitem(row) {
      this.$refs.score.update({
        courseExamId: row.courseExamId,
        courseExamName: row.courseExamName,
        examTime: row.examTime,
        queryScoreStatus: row.queryScoreStatus
      })
    },
    additem() {
      this.$refs.score.add(this.userInfo.orgId)
    },
    deleteitem(row) {
      console.log(row)
      this.$confirm('您确定删除该考试?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/deletecourseexam', {
          payload: {
            courseExamId: row.courseExamId
          },
          success: () => {
            this.loading = false
            this.getlist()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getcourseexams', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => {
            return {
              ...i,
              userCount: i.passedUserCount + i.notPassedUserCount
            }
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
